require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es7.symbol.async-iterator.js
// module id = ../../node_modules/core-js/modules/es7.symbol.async-iterator.js
// module chunks = 18